module.exports = __webpack_public_path__ + "img/snu_logo.05c70c8d.jpg";